import type { Component } from 'vue'
import {
  AdjustmentsHorizontalIcon,
  Bars3BottomLeftIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  CheckCircleIcon,
  CurrencyDollarIcon,
  EnvelopeIcon,
  GlobeAltIcon,
  HashtagIcon,
  HomeIcon,
  LinkIcon,
  ListBulletIcon,
  PhoneIcon,
  StarIcon,
  UserIcon
} from '@heroicons/vue/24/outline'
import type { QuestionCardStats as ReportingQuestionCardStats } from '../../services/questionReportingService'
import type { QuestionTypeDefinition } from '../../services/questionCatalog'
import type { SegmentEngagement } from '../../services/segmentEngagement'

/** Rates, shares and lifts are percentages, not fractions. Missing metrics never mean zero. */
export interface QuestionCardStats {
  status: 'loading' | 'ready' | 'error'
  data?: ReportingQuestionCardStats
  flows: number
  segmentsApplied?: number | null
  engagements?: Record<string, SegmentEngagement | null>
}

const icons: Record<QuestionTypeDefinition['id'], Component> = {
  mc: ListBulletIcon,
  yesno: CheckCircleIcon,
  name: UserIcon,
  email: EnvelopeIcon,
  phone: PhoneIcon,
  address: HomeIcon,
  country: GlobeAltIcon,
  url: LinkIcon,
  short: Bars3BottomLeftIcon,
  long: ChatBubbleLeftRightIcon,
  number: HashtagIcon,
  currency: CurrencyDollarIcon,
  date: CalendarDaysIcon,
  rating: StarIcon,
  nps: ChartBarIcon,
  slider: AdjustmentsHorizontalIcon,
  legacy: ChatBubbleLeftRightIcon
}

export function questionTypeIcon(type: QuestionTypeDefinition): Component {
  return icons[type.id]
}
